module.exports = __webpack_public_path__ + "img/BG_header_vin.9785f37c.jpg";